import {
  inspectionRequestTypes,
  handlingRequestExecutionOrder,
} from 'views/warehouse/utils';
import { HandlingRequestSchemaLite } from 'types/clientV2/stock';

export const getHighestPriorityRequest = (
  requests: HandlingRequestSchemaLite[] | undefined
): HandlingRequestSchemaLite | null => {
  if (!requests?.length) return null;

  const inspectionRequest = requests.find((request) =>
    inspectionRequestTypes.includes(request.requestType)
  );
  if (inspectionRequest) return inspectionRequest;

  for (const priorityType of handlingRequestExecutionOrder) {
    const matchingRequest = requests.find(
      (request) => request.requestType === priorityType
    );
    if (matchingRequest) return matchingRequest;
  }

  return requests[0];
};
